import { Capacitor } from '@capacitor/core';
import { logDebug, logError } from './log';

/**
 * OTA live updates (Capgo) — dev-only for now.
 *
 * `notifyAppReady()` must be called on every native launch: after the updater
 * installs a new bundle, it waits `appReadyTimeout` (10s default) for this
 * signal and rolls back to the previous bundle if it never arrives. That is
 * the whitescreen safety net, so call it as soon as the web app has booted.
 *
 * Safe to call in every binary: prod builds are synced with `autoUpdate: false`
 * and no registered Capgo app (see capacitor.config.ts), so the plugin is
 * dormant there and this is a no-op beyond marking the builtin bundle healthy.
 */
export function initOtaUpdates(): void {
  if (!Capacitor.isNativePlatform()) return;

  import('@capgo/capacitor-updater')
    .then(async ({ CapacitorUpdater }) => {
      await CapacitorUpdater.notifyAppReady();
      const { bundle } = await CapacitorUpdater.current();
      logDebug('OTA bundle ready', { id: bundle.id, version: bundle.version });
    })
    .catch((err) => logError(err, { context: 'ota_notify_app_ready' }));
}
